export default "__VITE_ASSET__DV6P6Pq3__"